<template>
  <div class="flex min-h-full flex-1 flex-col justify-center px-6 pt-24 sm:px-6 lg:px-8">
    <div class="mx-auto w-full max-w-sm">
      <WordmarkLogo class="mx-auto" />
    </div>

    <div class="mx-auto mt-8 w-full max-w-sm text-center">
      <font-awesome-icon
        icon="fa-sharp-duotone fa-solid fa-circle-exclamation"
        class="mx-auto mb-4 text-4xl text-danger"
      />
      <h1 class="mb-2 text-lg font-semibold">{{ t("msg.forceUpdateTitle") }}</h1>
      <p class="text-sm text-muted-foreground">{{ t("msg.forceUpdateBody") }}</p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

import WordmarkLogo from "../components/WordmarkLogo.vue";

const { t } = useI18n();
</script>
